/**
 * External dependencies
 */
import React from 'react';
import classNames from 'classnames';

/**
 * Internal dependencies
 */
import Icon from 'components/icon';

/**
 * Style dependencies
 */
import './styles.scss';

const EmptyContent = (props) => {
    const classes = classNames('me-empty-content', { 'me-empty-content--inline': props.inline});
    return (
        <div className={classes}>
            <div className='me-empty-content__icon'>
                <Icon name={props.iconName} type={props.iconType} />
            </div>
            <div className='me-empty-content__text-wrapper'>
                <p className='text-center'>{props.message}</p>
                {props.secondary && <p className='me-empty-content__text-secondary'>{props.secondary}</p>}
            </div>
        </div>
    );
};

EmptyContent.defaultProps = {};
EmptyContent.propTypes = {};

export default EmptyContent;
